export default __webpack_public_path__ + "static/media/error-fintro.cd80ece3.svg";